/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type CounselRole = 'as_patient' | 'as_doctor' | 'as_admin';

export const CounselRole = {
    Patient: 'as_patient' as CounselRole,
    Doctor: 'as_doctor' as CounselRole,
    Admin: 'as_admin' as CounselRole
};